import USER_PERMISSION_KEYS from '../../../../permissions/user.permissions';
import { REMOTE_USER_PERMISSION_KEYS } from '../../../../permissions/remote.permissions';

export default ({ user, permissions }) => ({
  [USER_PERMISSION_KEYS.VIEW_ALL_TEAMS]: () => {
    const allowed = !!permissions?.[REMOTE_USER_PERMISSION_KEYS.VIEW_ALL_TEAMS]?.allowed;
    const reason = allowed ? undefined : permissions?.[REMOTE_USER_PERMISSION_KEYS.VIEW_ALL_TEAMS]?.reason || 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
  [USER_PERMISSION_KEYS.POST_TO_MULTIPLE_TARGETS]: () => {
    const allowed = !!permissions?.[REMOTE_USER_PERMISSION_KEYS.POST_TO_MULTIPLE_TARGETS]?.allowed;
    const reason = allowed ? undefined : permissions?.[REMOTE_USER_PERMISSION_KEYS.POST_TO_MULTIPLE_TARGETS]?.reason || 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
  [USER_PERMISSION_KEYS.ACCESS_OWN_PROFILE]: () => {
    const allowed = user?.role !== 'admin';
    const reason = allowed ? undefined : 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
  [USER_PERMISSION_KEYS.INIT_MATCH_RUN]: () => {
    const allowed = !!permissions?.[REMOTE_USER_PERMISSION_KEYS.INIT_MATCH_RUN]?.allowed;
    const reason = allowed ? undefined : permissions?.[REMOTE_USER_PERMISSION_KEYS.INIT_MATCH_RUN]?.reason
      || 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
  [USER_PERMISSION_KEYS.CAN_INVEST]: () => {
    const allowed = permissions?.[REMOTE_USER_PERMISSION_KEYS.INVEST_IN_GENERAL]?.allowed;
    const reason = allowed ? undefined : permissions?.[REMOTE_USER_PERMISSION_KEYS.INVEST_IN_GENERAL]?.reason
      || 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
  [USER_PERMISSION_KEYS.INIT_BACKGROUND_CHECK]: () => {
    const allowed = !!permissions?.[REMOTE_USER_PERMISSION_KEYS.INIT_BACKGROUND_CHECK]?.allowed;
    const reason = allowed ? undefined : permissions?.[REMOTE_USER_PERMISSION_KEYS.INIT_BACKGROUND_CHECK]?.reason
      || 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
  [USER_PERMISSION_KEYS.ACCESS_RESOURCE_LIBRARY]: () => {
    const allowed = !!permissions?.[REMOTE_USER_PERMISSION_KEYS.ACCESS_RESOURCE_LIBRARY]?.allowed;
    const reason = allowed ? undefined : permissions?.[REMOTE_USER_PERMISSION_KEYS.ACCESS_RESOURCE_LIBRARY]?.reason
      || 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
  [USER_PERMISSION_KEYS.ACCESS_GROW]: () => {
    const allowed = !!permissions?.[REMOTE_USER_PERMISSION_KEYS.ACCESS_GROW]?.allowed;
    const reason = allowed ? undefined : permissions?.[REMOTE_USER_PERMISSION_KEYS.ACCESS_GROW]?.reason
      || 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
  [USER_PERMISSION_KEYS.CRUD_POSTS]: () => {
    const allowed = !!permissions?.[REMOTE_USER_PERMISSION_KEYS.CRUD_POSTS]?.allowed;
    const reason = allowed ? undefined : permissions?.[REMOTE_USER_PERMISSION_KEYS.CRUD_POSTS]?.reason
      || 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
  [USER_PERMISSION_KEYS.CRUD_GOALS]: () => {
    const allowed = !!permissions?.[REMOTE_USER_PERMISSION_KEYS.CRUD_GOALS]?.allowed;
    const reason = allowed ? undefined : permissions?.[REMOTE_USER_PERMISSION_KEYS.CRUD_GOALS]?.reason || 'FORBIDDEN';

    return {
      allowed,
      reason,
    };
  },
});
